<template>
  <svg ref="svg" id="svg" @click="onSvgClick">
    <g class="container">
      <image v-if="backgroundImage" :href="backgroundImage" height="200" width="200" :style="backgroundImageStyle" />
      <template v-for="el in getGeometry" :key="el.ID">
        <KobiRectangle @click.stop="clickedEl(el)" :data="el" v-if="el.Pbi2DGeometry && el.Pbi2DGeometry.PbiType=='KobiRectangle'" />
        <KobiPolygon @click.stop="clickedEl(el)" :data="el" v-if="el.Pbi2DGeometry && el.Pbi2DGeometry.PbiType=='KobiPolygon'" />
        <KobiSphere @click.stop="clickedEl(el)" :data="el" v-if="el.Pbi2DGeometry && el.Pbi2DGeometry.PbiType=='KobiSphere'" />
      </template>
    </g>
  </svg>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import KobiRectangle from './2DComponents/KobiRectangle.vue';
import KobiPolygon from './2DComponents/KobiPolygon.vue';
import KobiSphere from './2DComponents/KobiSphere.vue';
import { eventBus, Events } from "@/eventBus";

import * as d3 from 'd3';

export default {
  computed: {
    ...mapState('general', ['group', 'json', 'grouping', 'filter', 'backgroundImage', 'backgroundImageConfig']),
    ...mapGetters('general', ['getFilteredGroups','getJson', 'elementsWithViewTemplate', 'getSelectedElements']),
    ...mapGetters('settings', ["getSelectionMode"]),

    getGeometry() {
      if(this.group) {
        return this.elementsWithViewTemplate.filter(x => this.getFilteredGroups.some(y => y.group == x[this.group]));
      }
      return this.elementsWithViewTemplate;
    },

    backgroundImageStyle() {
      if(!this.backgroundImage || !this.backgroundImageConfig) return {};
      return {
        transform: `translate(${this.backgroundImageConfig.xoffset}px, ${this.backgroundImageConfig.yoffset}px)`,
        width: `${this.backgroundImageConfig.width}px`,
        height: `${this.backgroundImageConfig.height}px`,
      };
    },
  },

  watch: {
    json() {
      this.calculate();
    },
  },

  methods: {
    ...mapActions('general', ['calculate2D', 'changeSelected', 'changeTargetLocation']),

    onSvgClick() {
      this.changeSelected([]);
    },

    clickedEl(obj) {
      if(this.getSelectionMode=='multiple') {
        if(this.getSelectedElements.some(x => x.ID == obj.ID)) {
          this.changeSelected(this.getSelectedElements.filter(x => x.ID != obj.ID).map(x => x.ID));
        } else {
          this.changeSelected(this.getSelectedElements.map(x => x.ID).concat(obj.ID));
        }
      } else if(this.getSelectionMode=='single') {
        if(this.getSelectedElements.some(x => x.ID == obj.ID)) {
          this.changeSelected([]);
        } else {
          this.changeSelected([obj.ID]);
        }
      }
    },

    calculate() {
      this.calculate2D({
        width: this.$refs.svg.clientWidth,
        height: this.$refs.svg.clientHeight,
      });
    },


    zoomExtentsEvent() {
      this.calculate();
      const svg = d3.select("#svg");
      svg.transition().duration(500)
        .call(this.zoomSettings.transform, d3.zoomIdentity);
    },
  },

  components: { KobiRectangle, KobiPolygon, KobiSphere },
  
  data() {
    return {
      zoomSettings: null,
      container: null,
    }
  },
  
  mounted() {
    this.container = d3.select('.container');
    this.zoomSettings = d3.zoom()
    .scaleExtent([0.5, 100])
    .on("zoom", (attr) => {
      this.container.attr("transform", attr.transform)
    });
    d3.select("#svg").call(this.zoomSettings);
    this.calculate();

    eventBus.on(Events.ZOOM_EXTENTS, this.zoomExtentsEvent);
  },

  unmounted() {
    eventBus.off(Events.ZOOM_EXTENTS, this.zoomExtentsEvent);
  },
}
</script>

<style>
#svg {
  width: 100%;
  height: 100%;
  background: var(--surface-c);
  font-size: 1px;
}
</style>